import * as msalConfig from './msalConfig'
import * as msalBrowser from '@azure/msal-browser';

export interface IMsalAuthService {
    msal(): msalBrowser.IPublicClientApplication;
}

export class MsalAuthService implements IMsalAuthService {

    /*
     *  This class is meant as a wrapper for the PublicClientApplication object from msal-browser.
     *  We can add custom logic if necessary on top of what is provided by the PublicClientApplication object,
     *  else the consumers of this class can just work with MSAL directly through the msal() function.
     */ 

    private readonly _msalInstance: msalBrowser.IPublicClientApplication;

    constructor(private $location: ng.ILocationService) {
        let hostLocation = $location.host();
        if (hostLocation.search("localhost") !== -1) {
            this._msalInstance = new msalBrowser.PublicClientApplication(msalConfig.localMsalConfig);
        } else {
            this._msalInstance = new msalBrowser.PublicClientApplication(msalConfig.webMsalConfig);
        }
    }

    msal(): msalBrowser.IPublicClientApplication {
        return this._msalInstance;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/msal/msalAuthService.ts
 **/